import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export const secureEmailDomainRoutes: Routes = [
    {
        path: advaniaServicesSegments.secureEmailDomain,
        loadComponent: () =>
            import('./pages/secure-email-domain-page/secure-email-domain.page').then((m) => m.SecureEmailDomainPage),
    },
];
